import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const navLinks = [
  { id: "hero",         label: "Home" },
  { id: "projects",     label: "Projects" },
  { id: "achievements", label: "Achievements" },
  { id: "skills",       label: "Skills" },
  { id: "experience",   label: "Experience" },
  { id: "about",        label: "About" },
  { id: "contact",      label: "Contact" },
];

function NavBar() {
  const [scrolled,   setScrolled]   = useState(false);
  const [menuOpen,   setMenuOpen]   = useState(false);
  const [activeId,   setActiveId]   = useState("hero");
  const location  = useLocation();
  const navigate  = useNavigate();

  /* ── scroll + spy ── */
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);

      // section spy
      for (const { id } of [...navLinks].reverse()) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          setActiveId(id);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ── click handler ── */
  const handleNav = (id) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      // navigate home first, then scroll after mount
      navigate("/");
      setTimeout(() => scrollTo(id), 120);
    } else {
      scrollTo(id);
    }
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 70;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <nav className={`navbar-custom${scrolled ? " scrolled" : ""}`}>
      <div className="navbar-inner">
        {/* Logo */}
        <button className="nav-logo" onClick={() => handleNav("hero")}>
          &lt;SAS /&gt;
        </button>

        {/* Desktop links */}
        <div className="desktop-nav">
          {navLinks.map(({ id, label }) => (
            <button
              key={id}
              className={`nav-link-custom${activeId === id ? " active" : ""}`}
              onClick={() => handleNav(id)}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Hamburger */}
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span style={{ transform: menuOpen ? "rotate(45deg) translateY(6px)" : "none" }} />
          <span style={{ opacity: menuOpen ? 0 : 1 }} />
          <span style={{ transform: menuOpen ? "rotate(-45deg) translateY(-6px)" : "none" }} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu-dropdown">
          {navLinks.map(({ id, label }) => (
            <button
              key={id}
              className={`nav-link-custom${activeId === id ? " active" : ""}`}
              onClick={() => handleNav(id)}
              style={{ width: "100%", textAlign: "left" }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}

export default NavBar;
